import "./Page404.scss";
import { useTranslation } from "react-i18next";
import { addLocaleData } from "../../utils/utils.tsx";

const Page404 = ({ locale }: { locale: string }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="content-block page404">
        <div className="text-page">
          <div className="wrapper">
            <h1>404</h1>
            <div className="tabs">
              <div className="tabs-content">
                <div className="text-page__cont">
                  {t("The page you are looking for cannot be found")}
                </div>
                <a href={addLocaleData("/", locale)} className="back-button">
                  {t("Back to home")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page404;
